import React from 'react';
import { sponsors } from '../data/sponsors';

/**
 * Reusable grid of sponsor logos.
 * Reads from /src/data/sponsors.js so updates only need to happen in one place.
 *
 * Props:
 *  - className?: string – extra classes for the outer grid (optional)
 *  - tone?: 'light' | 'dark' – background tone for logo cards
 */
export const SponsorGrid = ({ className = '', tone = 'light' }) => {
  const cardBase =
    tone === 'dark'
      ? 'bg-white rounded-xl p-4 w-full max-w-[180px] aspect-square flex items-center justify-center hover:scale-105 transition-transform duration-300 border border-slate-200 hover:border-green-500 hover:shadow-lg'
      : 'bg-slate-50 dark:bg-slate-900 rounded-xl p-4 w-full max-w-[180px] aspect-square flex items-center justify-center hover:scale-105 transition-transform duration-300 border border-slate-200 dark:border-slate-700 hover:border-green-500 hover:shadow-lg';

  return (
    <div
      className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center justify-items-center ${className}`}
      data-testid="sponsor-grid"
    >
      {sponsors.map((sponsor) => (
        <a
          key={sponsor.name}
          href={sponsor.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Besøk ${sponsor.name}`}
          data-testid={`sponsor-${sponsor.name.toLowerCase().replace(/\s+/g, '-')}`}
          className={cardBase}
        >
          <img
            src={sponsor.logo}
            alt={sponsor.name}
            loading="lazy"
            className="max-h-full max-w-full object-contain"
          />
        </a>
      ))}
    </div>
  );
};

export default SponsorGrid;
